import * as React from 'react'

const ChevronRight = ({ className }) => {
    return (<svg width="16" height="16" viewBox="0 -1 16 16" className={'docs-icon ' + className} xmlns="http://www.w3.org/2000/svg">
        <path d="M4.93945 4.06066L8.87883 8.00003L4.93945 11.9394L6.00011 13L11.0001 8.00003L6.00011 3L4.93945 4.06066Z" />
    </svg>)
}

export default ChevronRight;